module.exports = __webpack_public_path__ + "aiicon-d797f22d.png";